import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { getDashboardPathForRole, getEffectiveRole, normalizeRole } from "../utils/authRoutes";
import { isAuthSessionValid } from "../utils/authSession";

/**
 * Guards dashboard routes. Redirects wrong-role users to their dashboard or login.
 * Requires a valid login/registration session in this tab — stale localStorage alone is not enough.
 */
export default function RequireRole({ role, children }) {
    const location = useLocation();
    const { currentUser, currentRole } = useSelector((state) => state.user);
    const expected = normalizeRole(role);
    const actual = getEffectiveRole(currentRole, currentUser);

    if (!actual || !currentUser || !isAuthSessionValid(currentUser)) {
        return <Navigate to="/login" replace state={{ from: location.pathname }} />;
    }

    if (actual !== expected) {
        const dest = getDashboardPathForRole(actual, currentUser);
        return <Navigate to={dest || "/login"} replace />;
    }

    return children;
}
